import { type RequestedResponder } from '../../common/types';

const REQUESTED_NO_ONE: RequestedResponder = {
	id: 'noone',
	type: 'noone',
} as const;

export { REQUESTED_NO_ONE };
